import throttle from 'lodash/throttle';

const $window = $(window);

class IScrollTo {
    constructor($el) {
        this.$el = $el;

        this.$activeElement = this.$el.eq(0);
        this.$activeElement.addClass('active');

        this.bindEvents();

        this.handleScroll();
    }

    bindEvents() {
        this.$el.on('click', (event) => {
            event.preventDefault();
            const element = $(event.currentTarget);
            const target = $(element.attr('href'));

            if (target.length > 0) {
                $('html, body').animate({
                    scrollTop: target.offset().top - 130,
                }, 500);
            }
        });

        $(window).on('scroll', throttle(this.handleScroll.bind(this), 50));
    }

    handleScroll() {
        const scrollTop = $window.scrollTop();

        this.$el.each((index, element) => {
            const $element = $(element);
            const target = $($element.attr('href'));

            if (target.length > 0) {
                const targetOffsetTop = target.offset().top - 140;

                if (scrollTop > targetOffsetTop) {
                    this.$activeElement.removeClass('active');
                    this.$activeElement = $element;
                    this.$activeElement.addClass('active');
                }
            }
        });
    }

    static handleSearchScrollToExpose() {
        const item = localStorage.getItem('scrollToElement');
        if (item !== null) {
            IScrollTo.scrollTo(item);
        }
    }

    static scrollTo(id) {
        const $el = $(`#${id}`);

        if ($el.length > 0) {
            localStorage.removeItem('scrollToElement');
            const scrollTop = $el.offset().top;
            window.scrollTo(0, scrollTop - 70);
        }
    }
}

const iScrollTo = {
    init() {
        const $el = $('.I-js-scrollTo');

        IScrollTo.handleSearchScrollToExpose();

        if ($el.length) {
            // eslint-disable-next-line no-new
            new IScrollTo($el);
        }
    },
};

export default iScrollTo;
